<template>
  <div class="staging">
    <div class="single-quantity">
      <!-- 搜索 -->
      <div class="search">
        <el-form ref="searchForm" :model="searchForm">
          <div class="row">
            <el-form-item label="仓库名称：" prop="warehouseId">
              <el-select
                class="white"
                clearable
                v-model="searchForm.warehouseId"
                placeholder="请选择仓库"
              >
                <el-option
                  v-for="item in warehouseList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期：" prop="date">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="btn-form">
              <el-button icon="el-icon-search" class="btn-blue" @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>

      <!-- 仓库项目单量占比图 -->
      <div class="single-quantity-content">
        <div class="pie-container" @click="cancelPieHign">
          <p class="pie-title">仓库项目单量占比图</p>
          <div id="myChart" :style="{ width: '100%', height: '24rem' }"></div>
        </div>
        <!-- 项目单量信息 -->
        <div class="project-info">
          <div class="table-title">
            <div class="table-title-content">
              <span class="table-title-content-name"
                >项目名称
                <span class="grey">（{{ projectInfoList.length }}）</span>
              </span>
              <span class="table-title-content-nums"
                >单量
                <span class="grey">（调整单量）</span>
              </span>
            </div>
          </div>
          <div class="table-content">
            <div class="table-main">
              <div
                class="table-main-row"
                v-for="(item, index) in projectInfoList"
                :key="index"
                @click="selectPieProject(index)"
              >
                <div class="project-name">
                  <div
                    class="round"
                    :style="`background: ${item.color};`"
                  ></div>
                  <p class="name">
                    {{ item.name }}（{{ item.warehouseName }}）
                  </p>
                </div>
                <div class="nums">
                  <span>{{ item.value }}</span>
                  <span class="nums-convert"
                    >（{{ item.orderNumConvert }}）</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="total-order">
            <span class="total-order-title">单量合计：</span>
            <div class="total-order-content">
              <span>{{ totalOrderNum }}</span>
              <span class="nums-convert">（{{ totalOrderNumConvert }}）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Staging from "models/operator/staging.js";
import warehouseMixins from "@/common/mixins/warehouse.js";
import colorMixins from "@/common/mixins/color.js";
import { formatTimeToDate, keepTwoDecimal, getPositiveInteger } from "common/js/util";
// 饼图实例
let initEchart = null
export default {
  mixins: [warehouseMixins, colorMixins],

  data() {
    return {
      searchForm: {
        warehouseId: "",
        date: this.timeDefault(),
      },
      selectDate: "",
      //日期选择范围在31天内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      // 项目信息列表
      projectInfoList: [],
      // 合计订单数量
      totalOrderNum: 0,
      // 合计折算后的订单数
      totalOrderNumConvert: 0,
      oldIndex: 0
    };
  },

  created() {
    this.initWarehouse();
    this.initSingleQuantityPieList();
  },

  destroyed() {
    initEchart.clear()
    initEchart = null
  },

  methods: {
    /**
     * @desc 默认选择前7天
     */
    timeDefault() {
      let date = new Date();
      const yesterday = formatTimeToDate(date.getTime() - 86400000);
      const firstDate = formatTimeToDate(date.getTime() - 86400000 * 7);
      let arr = [firstDate, yesterday];
      return arr;
    },

    search() {
      this.initSingleQuantityPieList();
    },

    /**
     * @desc 获取仓库项目单量占比图数据
     */
    initSingleQuantityPieList() {
      let warehouseId = this.searchForm.warehouseId;
      let startDate = this.searchForm.date ? this.searchForm.date[0] : "";
      let endDate = this.searchForm.date ? this.searchForm.date[1] : "";
      let data = {
        warehouseId,
        startDate,
        endDate,
      };
      Staging.getStagingPieData(data).then((res) => {
        if (res.success) {
          let arr = [];
          let totalOrderNum = 0;
          let totalOrderNumConvert = 0;
          res.result.map((i, index) => {
            let obj = {};
            obj.projectId = i.projectId;
            obj.name = i.projectName;
            obj.warehouseName = i.warehouseName;
            obj.value = getPositiveInteger(i.orderNum);
            obj.orderNumConvert = getPositiveInteger(i.orderNumConvert);
            obj.ratio = keepTwoDecimal(Number(i.ratio) * 100);
            obj.color = this.COLOR_LIST[index];
            totalOrderNum += Number(obj.value);
            totalOrderNumConvert += Number(obj.orderNumConvert);
            arr.push(obj);
          });
          this.totalOrderNum = keepTwoDecimal(totalOrderNum);
          this.totalOrderNumConvert = keepTwoDecimal(totalOrderNumConvert);
          this.projectInfoList = arr;
          this.createSingleQuantityPie(this.projectInfoList);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * @desc 创建仓库项目单量占比图
     */
    createSingleQuantityPie(data) {
      initEchart = this.$echarts.init(document.getElementById("myChart"));

      let firstDate = this.searchForm.date.length
        ? this.searchForm.date[0]
        : "";
      let endDate = this.searchForm.date.length ? this.searchForm.date[1] : "";
      // 当前选择时间段
      let dateStr = `${firstDate}至${endDate}`;

      initEchart.setOption({
        // 鼠标移动到饼图某一块时突出显示
        tooltip: {
          trigger: "item",
          borderWidth: 0,
          // 自定义
          formatter: function (params) {
            // 左边间隔
            let nameSpanHtml = `<span style="margin-left: 45px;"></span>`;
            // 右边间隔
            let valueSpanHtml = `<span style="margin-right: 50px;"></span>`;
            // marker为小圆点，seriesName为标题，data为数据
            let { marker, seriesName, data } = params;
            let str = "";
            str += `${seriesName} </br> ${marker} ${data.name} ${nameSpanHtml} ${data.value} ${valueSpanHtml} ${data.ratio}%</br>`;
            return str;
          },
        },
        legend: {
          // 关闭图例
          show: false,
        },
        color: this.COLOR_LIST,
        series: [
          {
            name: dateStr,
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            data: this.genData(data),
          },
        ],
      });

      // 获取当前series中data长度，后面遍历取消高亮
        let dataCount = data.length;
        // 鼠标进入高亮当前，取消其他高亮
        initEchart.on("mouseover", (e) => {
          initEchart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: e.dataIndex,
          });
          // 根据当前option中data的length，遍历取消其他高亮
          for(let i =0;i<dataCount;i++){
            if(i != e.dataIndex){
              initEchart.dispatchAction({
              type: "downplay",
              seriesIndex: 0,
              dataIndex: i,
            });
            }
          }
        });
        //鼠标移出后其他取消高亮
        initEchart.on("mouseout", () => {
          // 根据当前option中data的length，遍历取消其他高亮
          for(let i =0;i<dataCount;i++){
              initEchart.dispatchAction({
              type: "downplay",
              seriesIndex: 0,
              dataIndex: i,
            });
          }
        });
    },

    /** 
     * @desc 显示前5个百分比
    */
    genData(arr) {
      arr.forEach(function (item, index) {
        if (index < 5) {
          item.label = {
            show: true,
            position: 'outside',
            formatter: "{d}% "
          };
          item.labelLine = {
            show: true
          };
        } else {
          item.label = {
            show: false,
            position: 'center'
          };
          item.labelLine = {
            show: false
          };
        }
        // 扇形高亮设置
        item.itemStyle = {
          emphasis: {
            color: item.color,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      });
      return arr;
    },

    /** 
     * @desc 选择饼图项目
    */
    selectPieProject(index) {
      // 取消之前的高亮
      initEchart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: this.oldIndex,
      });
      // 设置高亮展示，seriesIndex：系列名，dataIndex：当前索引
      initEchart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: index,
      });
      this.oldIndex = index
    },

    cancelPieHign() {
      // 取消之前所有的高亮
      for(let i =0;i<this.projectInfoList.length;i++){
          initEchart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: i,
        });
      }
    }
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/operator/staging.scss";
</style>
